class FilterCount extends HTMLElement {
  constructor() {
    super();
    this.filterCount = null;
    this.setCount = (count) => {
      this.innerHTML = `
      <span aria-hidden="true">${count > 0 ? `(${count})` : ""}</span>
      `;
    };
  }
  countURLParams(){
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let count = 0;
    const searchString = "filter"; // The string to search for within parameter names or values

    for (const [key, value] of urlParams.entries()) {
        if (key.includes(searchString) || value.includes(searchString)) {
            count++;
        }
    }
    this.filterCount = count;
    this.setCount(this.filterCount);
    return
  }
  connectedCallback(){
    this.countURLParams();
  }

}

customElements.define("filter-count", FilterCount);